// extracted by mini-css-extract-plugin
export var styles = "region-module--styles--3oE_1";
export var zzz = "region-module--zzz--9IF5K";